import { getThemepalette } from 'config/theme'
import styled from 'styled-components'

/**
 * The shared stimulus reading shell should stay on the fixed light palette so
 * assessment and assignment viewers do not inherit dark-mode surfaces.
 */
const lightContentTheme = getThemepalette('light')

export const InstructionBanner = styled.div`
  width: 100%;
  min-height: 68px;
  gap: 5px;
  background: ${(props) => props.theme.colors.skeleton.primary};
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 12px;
`

export const InstructionBannerContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`

export const InstructionText = styled.span`
  font-size: 19px;
  line-height: 26px;
  color: #5371b7;
  padding: 0px;
  padding-left: 20px;

  p {
    font-size: 19px;
    line-height: 26px;
    color: #5371b7;
    margin-bottom: 0px;
    cursor: pointer;
  }
`

export const ReadingScroll = styled.div`
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const ReadingPanel = styled.section<{ $fullWidth: boolean }>`
  width: ${(props) => (props.$fullWidth ? '100%' : '50%')};
  flex-shrink: 0;
  min-width: 0;
  min-height: 0;
  background: ${lightContentTheme.colors.card.background};
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const TabsHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  background: ${(props) => props.theme.colors.surface.muted};
  height: 60px;
  min-height: 60px;
  max-height: 60px;
`

export const TabsGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid ${(props) => props.theme.colors.border.primary};
  flex-grow: 1;
  height: 60px;
  min-height: 60px;
`

export const TabButton = styled.button<{ $active?: boolean }>`
  border: 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.border.primary};
  width: 100%;
  padding: 0;
  height: 60px;
  min-height: 60px;
  border-radius: 0;
  font-size: 24px;
  font-family: ${(props) => props.theme.typography.fontNunito};
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  background: ${(props) =>
    props.$active
      ? props.theme.colors.surface.infoDark
      : props.theme.colors.card.background};
  color: ${(props) =>
    props.$active ? '#fff' : props.theme.colors.text.primary};
  transition: background-color 0.2s ease;
`

export const TabButtonContent = styled.span`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const TabHeaderActionButton = styled.span`
  display: flex;
  position: absolute;
  flex-direction: column;
  height: auto;
  right: 12px;
  gap: 5px;
`
export const TabHeaderActionIcon = styled.img<{ $disabled?: boolean }>`
  width: 19px;
  height: 19px;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.4 : 1)};
`
